export default "__VITE_ASSET__DWcmziLA__"